import { render } from "./TrendsCard.vue?vue&type=template&id=79867aae&scoped=true"
import script from "./TrendsCard.vue?vue&type=script&lang=js"
export * from "./TrendsCard.vue?vue&type=script&lang=js"

import "./TrendsCard.vue?vue&type=style&index=0&id=79867aae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79867aae"]])

export default __exports__